$mol_nav $mol_plugin
	cycle? false
	-
	mod_ctrl false
	mod_shift false
	mod_alt false
	-
	keys_x? /
	keys_y? /
	-
	current_x? null
	current_y? null
	-
	event_up? null
	event_down? null
	event_left? null
	event_right? null
	event *
		^
		keydown? <=> event_key? null
